import React from 'react'

import { LgySubsection } from 'app/components/util/lgy-section/LgySection'
import { LGYAddress } from 'app/components/util/lgy-field/LgyField'
import { formatPhone} from '../common/AssignmentUtils'

const NewProposedConstructionSection = ({ assignmentDetails }) =>
  <LgySubsection header='New or Proposed Construction' className='assignment-details-child'>
    <div className='usa-width-one-half'>
      <table>
        <caption>Builder Information</caption>
        <tbody>
          <tr>
            <th scope='row'>Builder name and ID:</th>
            <td>{assignmentDetails.builderName} – {assignmentDetails.builderId}</td>
          </tr>
          <tr>
            <th scope='row'>Address:</th>
            <td>
              <LGYAddress
                streetAddress1={assignmentDetails.builderAddressOne}
                streetAddress2={assignmentDetails.builderAddressTwo}
                city={assignmentDetails.builderCityName}
                state={assignmentDetails.builderStateCode}
                zip={assignmentDetails.builderZipPrefixNumber} />
            </td>
          </tr>
          <tr>
            <th scope='row'>Phone number:</th>
            <td>{formatPhone(assignmentDetails.builderPhoneNumber)}</td>
          </tr>
          <tr>
            <th scope='row'>Email:</th>
            <td>{assignmentDetails.builderEmail}</td>
          </tr>
          </tbody>
      </table>
      {(assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND'
          || assignmentDetails.appraisalCode === 'NADL') &&
      <table>
      <caption>Warrantor Information</caption>
        <tbody>
          <tr>
            <th scope='row'>Warrantor Name:</th>
            <td>{assignmentDetails.warrantorName}</td>
          </tr>
          <tr>
            <th scope='row'>Address:</th>
            <td>
              {assignmentDetails.warrantorAddressOne}
              <br />
              {assignmentDetails.warrantorAddressTwo}
              </td>
          </tr>
          <tr>
            <th scope='row'>Phone Number:</th>
            <td>{assignmentDetails.warrantorPhoneNumber}</td>
          </tr>
        </tbody>
      </table>}
    </div>
    <div className='usa-width-one-half'>
    {(assignmentDetails.appraisalCode === 'LPL' || assignmentDetails.appraisalCode === 'LGI'
      || assignmentDetails.appraisalCode === 'SAP') &&
    <table>
      <caption>Warrantor Information</caption>
        <tbody>
          <tr>
            <th scope='row'>Warrantor Name:</th>
            <td>{assignmentDetails.warrantorName}</td>
          </tr>
          <tr>
            <th scope='row'>Address:</th>
            <td>
              {assignmentDetails.warrantorAddressOne}
              <br />
              {assignmentDetails.warrantorAddressTwo}
              </td>
          </tr>
          <tr>
            <th scope='row'>Phone Number:</th>
            <td>{assignmentDetails.warrantorPhoneNumber}</td>
          </tr>
        </tbody>
      </table>}
    {(assignmentDetails.appraisalCode === 'LAPP' || assignmentDetails.appraisalCode === 'IND'
        || assignmentDetails.appraisalCode === 'NADL') &&
      <table>
        <caption>Builder Sales Office POC</caption> 
        <tbody>
          <tr>
            <th scope='row'>Builder Sales Office Name:</th>
            <td>{assignmentDetails.builderSalesOfficePocName}</td>
          </tr>
          <tr>
            <th scope='row'>Phone Number:</th>
            <td>
            {formatPhone(assignmentDetails.builderSalesOfficePocPhone)}
            </td>
          </tr>
          <tr>
            <th scope='row'>Email:</th>
            <td>{assignmentDetails.builderSalesOfficePocEmail}</td>
          </tr>
        </tbody>
      </table>}
    </div>
  </LgySubsection>

export default NewProposedConstructionSection
